import ApiService from './api.service'

const ActivityService = {
  index (searchData) {
    return ApiService.postWithoutLoading('api/v2/admin/activities', searchData)
  }
}

export default ActivityService
